import React from 'react';
import SinglePageLayout from './components/SinglePageLayout';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <SinglePageLayout />
    </div>
  );
}

export default App;
